// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TCU_headerRow__7OrLC {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.TCU_titleWrap__16IkS {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TCU_titleBar__BscZI { 
  width: 4px;
  height: 18px;
  border-radius: 2px;
  background: #2f7ed8;
  flex-shrink: 0;
}

.TCU_title__s9qKb {
  font-weight: 600;
  color: #1f2937;
  font-size: 0.95rem;
}

.TCU_subtitle__z87V5 {
  color: #9ca3af;
  font-size: 0.78rem;
  margin-left: 6px;
}

/* card header download icon (Latency trend, Device Health, Layer-wise latency) */
.TCU_downloadBtn__nVZ6- {
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border: 0;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
}

.TCU_downloadBtn__nVZ6-:hover {
  color: #022352;
}

.TCU_downloadBtn__nVZ6-:focus-visible {
  outline: 2px solid #4b71a2;
  outline-offset: 1px;
}

.TCU_downloadBtn__nVZ6-:disabled {
  opacity: 0.4;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/SmartCIty/TCU/TCU.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.titleWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.titleBar { \n  width: 4px;\n  height: 18px;\n  border-radius: 2px;\n  background: #2f7ed8;\n  flex-shrink: 0;\n}\n\n.title {\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 0.95rem;\n}\n\n.subtitle {\n  color: #9ca3af;\n  font-size: 0.78rem;\n  margin-left: 6px;\n}\n\n/* card header download icon (Latency trend, Device Health, Layer-wise latency) */\n.downloadBtn {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px;\n  border: 0;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.downloadBtn:hover {\n  color: #022352;\n}\n\n.downloadBtn:focus-visible {\n  outline: 2px solid #4b71a2;\n  outline-offset: 1px;\n}\n\n.downloadBtn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `TCU_headerRow__7OrLC`,
	"titleWrap": `TCU_titleWrap__16IkS`,
	"titleBar": `TCU_titleBar__BscZI`,
	"title": `TCU_title__s9qKb`,
	"subtitle": `TCU_subtitle__z87V5`,
	"downloadBtn": `TCU_downloadBtn__nVZ6-`
};
export default ___CSS_LOADER_EXPORT___;
